import { eraseUserSessionIdCookie } from './cookieOperations'
import { setUserSessionInfo } from './userAuthStore'
import identifyUser from '../tracking/identifyUser'
import { resetUploadFallback } from './authFetchHandler'

const handleLogout = () => {
  eraseUserSessionIdCookie(null)
  setUserSessionInfo(null)
  identifyUser(null)
  resetUploadFallback()
}

export default handleLogout